export function ArrowSvg({ className, onClick }: { className: string, onClick: () => void }) {
    return (
        <svg onClick={onClick} className={className} xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <g clipPath="url(#clip0_2372_4902)">
                <path d="M6.46084 2.50503C6.7342 2.23166 7.17742 2.23166 7.45079 2.50503L11.9056 6.9598C12.1789 7.23317 12.1789 7.67638 11.9056 7.94975C11.6322 8.22311 11.189 8.22311 10.9156 7.94975L6.95581 3.98995L2.99601 7.94975C2.72265 8.22311 2.27943 8.22311 2.00606 7.94975C1.7327 7.67638 1.7327 7.23316 2.00606 6.9598L6.46084 2.50503ZM6.25581 4L6.25581 3L7.65581 3L7.65581 4L6.25581 4Z" fill="#A2AFD0" />
            </g>
            <defs>
                <clipPath id="clip0_2372_4902">
                    <rect width="12" height="12" fill="white" transform="matrix(1 0 0 -1 0.955811 12)" />
                </clipPath>
            </defs>
        </svg>
    )
}